import { useEffect, useRef, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";

import { Tooltip } from "@mui/material";
import { LogoutTwoTone } from "@mui/icons-material";

import { getUser, createUser } from "../actions/index";
import * as api from "../api";

const GoogleAuth = () => {
  const [userId, setUserId] = useState(localStorage.getItem("userid"));

  const signInBtn = useRef();
  const dispatch = useDispatch();

  const handleSignIn = useCallback(
    async (response) => {
      let payload = await jwt_decode(response.credential);
      localStorage.setItem("userid", payload.sub);
      setUserId(payload.sub);

      let { data } = await api.getUser(payload.sub);
      if (data[0]) {
        dispatch(getUser(payload.sub));
      } else {
        dispatch(
          createUser({
            id: payload.sub,
            name: payload.name,
            email: payload.email,
          })
        );
      }
      window.location.reload(true);
    },
    [dispatch]
  );

  const handleSignOut = () => {
    localStorage.clear();
    setUserId(null);
    window.location.reload(true);
  };

  useEffect(() => {
    window.google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENTID,
      callback: handleSignIn,
      auto_select: true,
    });
    window.google.accounts.id.renderButton(signInBtn.current, {
      type: "standard",
      text: "signin",
      size: "small",
      theme: "outline",
    });
  }, [handleSignIn, userId]);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {userId ? (
        <Tooltip title="Log out">
          <LogoutTwoTone
            sx={{ cursor: "pointer" }}
            onClick={() => handleSignOut()}
          />
        </Tooltip>
      ) : (
        <div ref={signInBtn}></div>
      )}
    </div>
  );
};

export default GoogleAuth;

//link google signin confirmation and create a new user in database
